/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The signing algorithm of the key.
 */
export const Algorithm = {
  Rs256: "RS256",
  Es256: "ES256",
} as const;
/**
 * The signing algorithm of the key.
 */
export type Algorithm = ClosedEnum<typeof Algorithm>;

export type CreateAwsKmsKeyForm = {
  /**
   * The signing algorithm of the key.
   */
  algorithm: Algorithm;
  /**
   * Optional. The Speakeasy identity (GCP service-account email or AWS principal ARN) the customer granted on the key for the key-policy / IAM-grant model. Not a secret.
   */
  customerGrantReference?: string | undefined;
  /**
   * The external credential Speakeasy uses to authenticate to the key. Must belong to the same organization and matching cloud family (an aws_kms key requires an aws_iam credential; a gcp_kms key requires a gcp_iam credential).
   */
  externalCredentialId: string;
  /**
   * The ARN of the AWS KMS key.
   */
  keyArn: string;
  /**
   * A human-readable name for the key.
   */
  name: string;
};

/** @internal */
export const Algorithm$outboundSchema: z.ZodMiniEnum<typeof Algorithm> = z.enum(
  Algorithm,
);

/** @internal */
export type CreateAwsKmsKeyForm$Outbound = {
  algorithm: string;
  customer_grant_reference?: string | undefined;
  external_credential_id: string;
  key_arn: string;
  name: string;
};

/** @internal */
export const CreateAwsKmsKeyForm$outboundSchema: z.ZodMiniType<
  CreateAwsKmsKeyForm$Outbound,
  CreateAwsKmsKeyForm
> = z.pipe(
  z.object({
    algorithm: Algorithm$outboundSchema,
    customerGrantReference: z.optional(z.string()),
    externalCredentialId: z.string(),
    keyArn: z.string(),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      customerGrantReference: "customer_grant_reference",
      externalCredentialId: "external_credential_id",
      keyArn: "key_arn",
    });
  }),
);

export function createAwsKmsKeyFormToJSON(
  createAwsKmsKeyForm: CreateAwsKmsKeyForm,
): string {
  return JSON.stringify(
    CreateAwsKmsKeyForm$outboundSchema.parse(createAwsKmsKeyForm),
  );
}
